export default "__VITE_ASSET__7ad39378__"